module.exports = __webpack_public_path__ + "img/媒势通.c81cbd25.jpg";